
import { useState } from "react";
import classes from "./Sources.module.css";
import { getSourcesWithAlias } from "../../../services/apiService";

export default function Sources({ sources }) {
  const [activeTooltip, setActiveTooltip] = useState(null); // { index: number, urls: [] }
  const [loading, setLoading] = useState(null);

  const handleSourceClick = async (source, index) => {
    // If same tooltip is already open, do nothing
    if (activeTooltip?.index === index) return;

    setLoading(index);
    try {
      const response = await getSourcesWithAlias({
        sources: [source],
        sourceAliasIds: [],
      });

      const urls = response?.data?.[0]?.source_aliases?.map((item) => item?.url) || [];
      setActiveTooltip({ index, urls });
    } catch (err) {
      console.error("Error fetching source URLs", err);
      setActiveTooltip({ index, urls: ["Error loading URLs"] });
    }
    setLoading(null);
  };

  const handleCloseTooltip = () => {
    setActiveTooltip(null);
  };

  return (
    <ul className={classes.source_list}>
      {sources.map((source, index) => (
        <li
          key={index}
          className={classes.source_item}
          onClick={() => handleSourceClick(source, index)}
        >
          {source}
          {loading === index && <span className={classes.loader}>Loading...</span>}

          {activeTooltip?.index === index && (
            <div className={classes.tooltip}>
              <button
                className={classes.close_button}
                onClick={(e) => {
                  e.stopPropagation(); // prevent re-triggering click
                  handleCloseTooltip();
                }}
              >
                ×
              </button>
              {activeTooltip.urls.map((url, i) => (
                <a
                  key={i}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.tooltip_link}
                >
                  {url}
                </a>
              ))}
            </div>
          )}
        </li>
      ))}
    </ul>
  );
}



